import { render, staticRenderFns } from "./PowerSettingBlock.vue?vue&type=template&id=ecf81914&"
import script from "./PowerSettingBlock.vue?vue&type=script&lang=js&"
export * from "./PowerSettingBlock.vue?vue&type=script&lang=js&"
import style0 from "./PowerSettingBlock.vue?vue&type=style&index=0&id=ecf81914&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports